import type { BrokerContact } from './comercial'

export interface PortaisAtendimentoBrokerRow {
  id: string
  name: string
  classification: string | null
  classification_previous: string | null
  state: string | null
  city: string | null
  last_access_date: string | null
  last_sale_date: string | null
  id_scgp: number | null
}

export interface PortaisAtendimentoBrokerDetail {
  id: string
  name: string
  holder_name: string | null
  classification: string | null
  classification_previous: string | null
  state: string | null
  city: string | null
  id_scgp: number | null
  status: string | null
  tax_id: string | null
  type: string | null
  last_access_date: string | null
  last_sale_date: string | null
  clients_count: number | null
  active_agreements_count: number | null
  scgp_registered_at: string | null
  scgp_last_update_at: string | null
  created_at: string | null
  [key: string]: unknown
}

export interface PortaisAtendimentoBrokerSearchFilters {
  code?: string
  name?: string
  classification?: string
  state?: string
  city?: string
}

export interface PortaisAtendimentoBrokerDetailResult {
  broker: PortaisAtendimentoBrokerDetail
  contacts: BrokerContact[]
}

export interface PortaisAtendimentoCallQueueEntry {
  id: string
  broker_id: string
  reason: string
  sort_order: number | null
  created_at: string
}

export interface PortaisAtendimentoCallQueueItem extends PortaisAtendimentoCallQueueEntry {
  broker_name: string
  broker_classification: string | null
  broker_id_scgp: number | null
}

export const PORTAIS_ATENDIMENTO_FILA_LIGACAO_CATEGORIAS_KEY = 'fila_ligacao_categorias'
export const PORTAIS_ATENDIMENTO_FILA_LIGACAO_PRODUCAO_MINIMA_KEY = 'fila_ligacao_producao_minima'
export const PORTAIS_ATENDIMENTO_PERIODO_DISPONIVEL_COTACAO_KEY = 'periodo_disponivel_cotacao'

/** Keys exibidas na subaba Outros (Parâmetros). */
export const PORTAIS_ATENDIMENTO_OUTROS_PARAMETER_KEYS = [
  PORTAIS_ATENDIMENTO_PERIODO_DISPONIVEL_COTACAO_KEY,
] as const

export interface HelpdeskParameter {
  id: string
  key: string
  value: string | null
  description: string | null
  created_at: string
  updated_at: string
}

export function parseFilaLigacaoCategorias(value: string | null | undefined): string[] {
  if (!value?.trim()) return []
  try {
    const parsed = JSON.parse(value)
    if (!Array.isArray(parsed)) return []
    return parsed.filter((item): item is string => typeof item === 'string' && item.trim().length > 0)
  } catch {
    return []
  }
}

export function serializeFilaLigacaoCategorias(names: string[]): string {
  const normalized = Array.from(
    new Set(names.map((name) => name.trim()).filter(Boolean))
  )
  return JSON.stringify(normalized)
}

export function parseFilaLigacaoProducaoMinima(value: string | null | undefined): number | null {
  if (value == null || !String(value).trim()) return null
  const n = Number(String(value).replace(',', '.'))
  return Number.isFinite(n) && n >= 0 ? n : null
}

/** Vazio/null vira string vazia — permite “sem número” sem exigir NULL no banco. */
export function serializeFilaLigacaoProducaoMinima(value: number | null): string {
  if (value == null) return ''
  const n = Number.isFinite(value) && value >= 0 ? value : null
  return n == null ? '' : String(n)
}

/** Meses anteriores à data atual (≥ 1). Inválido retorna null. */
export function parsePeriodoDisponivelCotacao(value: string | null | undefined): number | null {
  if (value == null || !String(value).trim()) return null
  const n = Number(String(value).trim().replace(',', '.'))
  if (!Number.isFinite(n)) return null
  const months = Math.trunc(n)
  return months >= 1 ? months : null
}

export function serializePeriodoDisponivelCotacao(months: number): string {
  const n = Math.trunc(Number(months))
  if (!Number.isFinite(n) || n < 1) {
    throw new Error('Informe um número inteiro de meses maior ou igual a 1.')
  }
  return String(n)
}
